import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { initResizeListener } from '@store/middleware/screenResize';
import rootReducer from './RootReducer';

export default function configureStore(preloadedState) {
  const middleware = applyMiddleware(thunk);
  const composeEnhancers = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;

  const store = createStore(rootReducer, preloadedState, composeEnhancers(middleware));
  // todo(oscar): this doesn't need to be here, can be moved to app component and state slice
  initResizeListener(store);
  return store;
}
